<template>
    <nav class="mt-3" aria-label="Пагинация">
        <ul v-if="count > 1" class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: current_page === 1 }">
                <a class="page-link" href="" v-on:click="changePage(current_page - 1)">
                    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 0.5L1 5.5L6 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </a>
            </li>

            <li v-if="(current_page - 3) >= 1" class="page-item">
                <a class="page-link" href="" v-on:click="changePage(1)">1</a>
            </li>

            <li v-if="(current_page - 4) >= 1" class="page-item">
                <a class="page-link">...</a>
            </li>
            <li v-if="(current_page - 2) >= 1" class="page-item">
                <a class="page-link" href="" v-on:click="changePage(current_page - 2)">{{ current_page - 2 }}</a>
            </li>

            <li v-if="(current_page - 1) >= 1" class="page-item">
                <a class="page-link" href="" v-on:click="changePage(current_page - 1)">{{ current_page - 1 }}</a>
            </li>

            <li class="page-item active">
                <a class="page-link">{{ current_page }}</a>
            </li>

            <li v-if="(current_page + 1) <= count" class="page-item">
                <a class="page-link" href="" v-on:click="changePage(current_page + 1)">{{ current_page + 1 }}</a>
            </li>

            <li v-if="(current_page + 2) <= count" class="page-item">
                <a class="page-link" href="" v-on:click="changePage(current_page + 2)">{{ current_page + 2 }}</a>
            </li>

            <li v-if="(current_page + 4) <= count" class="page-item">
                <a class="page-link">...</a>
            </li>

            <li v-if="(current_page + 3) <= count" class="page-item">
                <a class="page-link" href="" v-on:click="changePage(count)">{{ count }}</a>
            </li>
            <li class="page-item" :class="{ disabled: current_page === count }">
                <a class="page-link" href="" v-on:click="changePage(current_page + 1)">
                    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 0.5L6 5.5L1 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
import ChangePage from "../helpers/ChangePage";

export default {
    name: "PaginationElement",
    props: {
        count: {
            type: Number,
            default: 1
        },
        current_page: {
            type: Number,
            default: 1
        }
    },
    emits: ["pageChange"],
    methods: {
        ChangePage,
        changePage: function (page) {
            ChangePage(page);
            this.$emit('pageChange', page);
        }
    }
}
</script>

<style scoped>
.left-block {
    padding-right: 5px;
}

.center-block {
    padding-right: 5px;
}
</style>

